var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrk12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wrk-12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.684,
    height: 94.375,
    viewBox: "0 0 107.684 94.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1452",
    "data-name": "Rectangle 1452",
    width: 107.684,
    height: 94.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11102",
    "data-name": "Path 11102",
    d: "M25.074,16.564A48.478,48.478,0,0,0,30.946,71.7c1.649,1.625,3.4,3.241,5.193,4.8l.444.386c1.028.894,2.189,1.906,3.393,2.9a48.082,48.082,0,0,0,14.737,6.884,48.127,48.127,0,0,0,13.511-6.061c.534-.415,1.053-.824,1.549-1.215l.1-.082a101.151,101.151,0,0,0,8.648-7.667,48.478,48.478,0,0,0,5.838-55.064A52.848,52.848,0,0,0,54.7,7.712a52.866,52.866,0,0,0-29.629,8.852",
    transform: "translate(-19.076 -7.712)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    "data-name": "Rectangle 1448",
    width: 71.273,
    height: 78.963,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1450",
    "data-name": "Rectangle 1450",
    width: 65.388,
    height: 55.516,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11114",
    "data-name": "Path 11114",
    d: "M89.554,28.716S86.312,18.644,84.76,16.559c0,0-28.749-20.152-59.288.022,0,0,43.634,5.79,59.429,46.544,2.281-5.154,4.5-9.781,5.269-15.4.809-5.9,1.232-13.263-.616-19",
    transform: "translate(-25.472 -7.609)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.369,
    y1: 1.474,
    x2: -0.354,
    y2: 1.474,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6d2d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#a6d2d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69b4c0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3439",
    "data-name": "Group 3439",
    transform: "translate(18.205 7.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3438",
    "data-name": "Group 3438",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3437",
    "data-name": "Group 3437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3436",
    "data-name": "Group 3436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3435",
    "data-name": "Group 3435",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_1447",
    "data-name": "Rectangle 1447",
    width: 71.462,
    height: 79.021,
    transform: "translate(-0.111 -0.022)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3446",
    "data-name": "Group 3446",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3445",
    "data-name": "Group 3445",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11103",
    "data-name": "Path 11103",
    d: "M87.966,13.587l-.261-.462-.434-.3A57.476,57.476,0,0,0,54.479,2.793a57.5,57.5,0,0,0-32.759,10l-.434.3-.261.462A53.175,53.175,0,0,0,27.24,74.628l.12.128c1.739,1.716,3.581,3.421,5.474,5.068l.441.384c1.071.931,2.284,1.987,3.562,3.042l.154.116A52.741,52.741,0,0,0,53.9,91.152l.591.154.591-.154a52.793,52.793,0,0,0,15.563-6.881l.157-.112c.573-.445,1.126-.881,1.656-1.3l.1-.081a105.767,105.767,0,0,0,9.115-8.087l.115-.123a53.176,53.176,0,0,0,6.178-60.982M54.488,88.881c-1.634.425-5.641-1.8-7.162-2.451a51.192,51.192,0,0,1-6.9-3.608c-4.306-2.683-7.827-6.192-11.417-9.735A50.826,50.826,0,0,1,23.066,14.72,54.771,54.771,0,0,1,54.479,5.14a54.77,54.77,0,0,1,31.444,9.6,50.574,50.574,0,0,1,6.549,24.964,51.133,51.133,0,0,1-.942,9.788A51.6,51.6,0,0,1,54.488,88.881",
    transform: "translate(-0.646 -0.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11104",
    "data-name": "Path 11104",
    d: "M54.353,94.375l-1.118-.291c-17.875-4.646-32.659-18.7-38.862-36.031A54.635,54.635,0,0,1,11.2,39.668a56.241,56.241,0,0,1,7.264-27.652l.493-.873.823-.576A60.664,60.664,0,0,1,54.343,0a60.646,60.646,0,0,1,34.6,10.591l.821.575.493.873A56.24,56.24,0,0,1,97.5,39.668c0,19.173-10.394,37.392-26.51,47.6A54.913,54.913,0,0,1,55.47,94.084ZM37.324,83.447a53.526,53.526,0,0,0,9.39,5.24q1.854.8,3.764,1.454c.852.292,3.007,1.393,3.876,1.167a53.681,53.681,0,0,0,33.184-78.27A58.219,58.219,0,0,0,54.343,2.91a58.228,58.228,0,0,0-33.16,10.1,53.677,53.677,0,0,0,6.283,61.618,54.3,54.3,0,0,0,9.858,8.814",
    transform: "translate(-0.511 0)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11105",
    "data-name": "Path 11105",
    d: "M19.786,47.73s.281,27.2,32.432,40.106c0,0-25.165-14.473-32.432-40.106",
    transform: "translate(-0.903 -2.178)",
    fill: "#00718a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11106",
    "data-name": "Path 11106",
    d: "M56.417,88.475S88.872,79.429,91.7,47.135c0,0-2.139,27.578-35.281,41.34",
    transform: "translate(-2.575 -2.151)",
    fill: "#00718a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11107",
    "data-name": "Path 11107",
    d: "M32.018,12.928S59.358,1.3,84.953,16.581c0,0-22.476-17.4-52.935-3.653",
    transform: "translate(-1.461 -0.348)",
    fill: "#00718a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11108",
    "data-name": "Path 11108",
    d: "M87.081,55.71S90.62,25.144,79.1,16.747c0,0,4.84,1.031,6.97,3.853,3.606,4.779,5.7,15.919,1.014,35.111",
    transform: "translate(-3.61 -0.764)",
    fill: "#2e9aab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11109",
    "data-name": "Path 11109",
    d: "M55.484,77.683l.715-1.857,1.142,1.714,2,.143L57.77,79.255,58.2,81.54l-1.858-1-2,.715.429-1.715L53.2,77.968Z",
    transform: "translate(-2.428 -3.461)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11110",
    "data-name": "Path 11110",
    d: "M79.285,58.516l.5-1.312.807,1.211,1.412.1-1.11,1.11.3,1.615-1.312-.706-1.412.5.3-1.211-1.11-1.111Z",
    transform: "translate(-3.545 -2.611)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11111",
    "data-name": "Path 11111",
    d: "M32.54,58.516l.5-1.312.807,1.211,1.412.1-1.11,1.11.3,1.615-1.312-.706-1.412.5.3-1.211-1.11-1.111Z",
    transform: "translate(-1.412 -2.611)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11112",
    "data-name": "Path 11112",
    d: "M62.8,75.778l-.261-.585A37.26,37.26,0,0,0,75.489,64.534L76,64.92A37.946,37.946,0,0,1,62.8,75.778",
    transform: "translate(-2.855 -2.945)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11113",
    "data-name": "Path 11113",
    d: "M49.053,75.32A37.957,37.957,0,0,1,36.182,64.066l.524-.369A37.251,37.251,0,0,0,49.331,74.743Z",
    transform: "translate(-1.652 -2.907)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3444",
    "data-name": "Group 3444",
    transform: "translate(24.309 7.261)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3443",
    "data-name": "Group 3443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3441",
    "data-name": "Group 3441",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3440",
    "data-name": "Group 3440",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1449",
    "data-name": "Rectangle 1449",
    width: 65.93,
    height: 66.718,
    transform: "translate(0 -11.202)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11115",
    "data-name": "Path 11115",
    d: "M103.5,34.723l-.918-.222-.655.683q-2,2.09-4,4.223l-1.334,1.42q-1.452,1.55-2.895,3.11l-1.666,1.8v-7.3l4.235.827V33.117l-1.323-.261c-3.906-.771-7.883-1.436-11.822-1.976l-1.864-.256v1.581L79.8,31.331A9.825,9.825,0,0,0,75.679,30a8.052,8.052,0,0,0-9.345,8.523,10.14,10.14,0,0,0,.07,1.134l.126,1.121-1.684-.085c-.27-.014-.539-.029-.81-.041l-.92-.038V29.131l-1.592-.047c-.671-.02-1.342-.032-2.013-.045l-3.336-.055-.548.01h-.175c-2.574,0-5.186.05-7.765.148l-1.578.06v1.035L44.836,29.8a7.694,7.694,0,0,0-3.041-.346c-.771.052-2,.19-3.448.387-.6.052-1.143.1-1.69.151l-1.489.138V47.575l1.791-.166q1.565-.145,3.131-.264l1.515-.117V42l.827-.116a7.428,7.428,0,0,0,2.289-.7L46.11,40.5v6.265l1.7-.065c3.1-.118,6.246-.165,9.359-.138l1.034.011c3.105.043,6.253.159,9.355.347l1.74.1V45.4l1.454.87a9.98,9.98,0,0,0,4.194,1.354A8.792,8.792,0,0,0,81.437,46a7.071,7.071,0,0,0,2.228-2.921l1.848-4.422V48.816l1.383.22q1.608.256,3.21.536l1.564.281c1.2.22,2.4.453,3.577.691l.894.18,2.169-2.3.532.118q.666.147,1.332.3l.746.171v2.757l1.258.3q1.573.376,3.14.779l2.048.526V35.7l-1.232-.317q-1.317-.338-2.636-.659",
    transform: "translate(-1.605 -1.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11116",
    "data-name": "Path 11116",
    d: "M106.522,33.429q-1.328-.342-2.661-.664l-2-.485-1.419,1.485q-1.174,1.228-2.351,2.474V31.448l-2.872-.568c-3.942-.778-7.957-1.449-11.934-1.994l-4.045-.554v.525A12.118,12.118,0,0,0,75.778,28a10.336,10.336,0,0,0-8.053,2.334,9.571,9.571,0,0,0-2.78,4.15V27.175l-3.457-.1q-.68-.02-1.361-.032V27l-4.579-.042-.974,0v.014c-2.343.009-4.711.058-7.052.147L44.1,27.26v.3a10.286,10.286,0,0,0-2.522-.12c-.813.055-2.083.2-3.529.4q-.829.07-1.658.146l-3.232.3V49.592l3.89-.361q1.55-.145,3.1-.262l3.289-.253V43.544q.335-.076.661-.177v5.3l3.7-.141c3.072-.116,6.185-.163,9.27-.136l1.024.011c3.076.043,6.193.158,9.265.344l3.777.229v-.415a12.172,12.172,0,0,0,3.542.882,10.66,10.66,0,0,0,7.851-2.015,8.884,8.884,0,0,0,.977-.873v3.811l3,.477q1.59.252,3.179.531l1.549.278c1.189.219,2.381.449,3.543.684l1.94.392,2.151-2.278.042.01V53.2l2.732.655q1.556.374,3.109.772l4.447,1.141V34.116Zm.754,19.86-2.048-.526q-1.568-.4-3.14-.779l-1.259-.3V48.926l-.746-.171q-.666-.152-1.331-.3l-.533-.118-2.168,2.3-.894-.181c-1.173-.237-2.376-.47-3.577-.69l-1.564-.281q-1.6-.281-3.21-.536l-1.383-.22V38.567l-1.848,4.421a7.073,7.073,0,0,1-2.228,2.921,8.792,8.792,0,0,1-6.489,1.621,9.976,9.976,0,0,1-4.194-1.354l-1.454-.87v1.629l-1.741-.1c-3.1-.188-6.248-.3-9.354-.347l-1.035-.011c-3.112-.027-6.258.02-9.358.137l-1.7.066V40.409l-1.387.687a7.47,7.47,0,0,1-2.289.7l-.827.116v5.027L40,47.052q-1.566.12-3.13.265l-1.792.166V30.036l1.489-.138c.547-.051,1.095-.1,1.691-.151,1.453-.2,2.677-.335,3.447-.387a7.7,7.7,0,0,1,3.042.346l1.273.439V29.109l1.579-.06c2.578-.1,5.191-.148,7.765-.148h.175l.547-.01,3.336.055c.672.012,1.343.024,2.014.044l1.591.048V40.522l.92.038c.272.011.541.027.81.041l1.684.085-.125-1.121a10.154,10.154,0,0,1-.07-1.134,8.052,8.052,0,0,1,9.344-8.523,9.807,9.807,0,0,1,4.123,1.331l1.456.876V30.534l1.863.256c3.939.539,7.916,1.2,11.822,1.976l1.323.261v6.148l-4.234-.827v7.3l1.666-1.8q1.443-1.559,2.894-3.109l1.335-1.42q2-2.127,4-4.223l.655-.684.918.223q1.318.321,2.636.659l1.232.316Z",
    transform: "translate(-1.513 -1.23)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11117",
    "data-name": "Path 11117",
    d: "M24.03,31.259l-.7.1-.4.575c-2.8,3.982-5.638,8.078-8.426,12.176l-.219.321-1.712.355q-1.464.3-2.934.631l-1.17.261V34.194l-2.022.485q-1.6.384-3.2.794l-1.233.317V53.457l2.049-.526c3.023-.777,6.11-1.493,9.173-2.127l.409-.085c1.1-.226,2.221-.447,3.331-.654l.664-.125c.47-.679,1.547-2.236,1.951-2.816l.23-.331,2.251-.378v2.753l1.887-.285q1.59-.24,3.187-.456l1.421-.191V30.63l-1.86.25Q25.367,31.06,24.03,31.259Z",
    transform: "translate(-0.092 -1.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11118",
    "data-name": "Path 11118",
    d: "M26.358,28.871q-1.353.182-2.7.382l-1.51.224-.879,1.248c-2.736,3.885-5.5,7.88-8.226,11.879l-.951.2q-.895.185-1.792.38V31.653L5.907,32.7q-1.618.388-3.231.8L0,34.193V55.829l4.448-1.141c2.994-.769,6.051-1.478,9.084-2.106l.408-.085c1.091-.223,2.2-.442,3.3-.648l1.441-.27.224-.324s.576-.834,1.156-1.67V51.3l4.094-.618q1.576-.239,3.157-.451l3.085-.416V28.328Zm2.116,19.26-1.421.192q-1.595.215-3.187.455l-1.887.285V46.31l-2.251.378-.23.331c-.4.58-1.48,2.137-1.951,2.816l-.664.125c-1.11.207-2.227.428-3.33.654l-.41.085c-3.063.635-6.15,1.35-9.173,2.127l-2.049.526V35.684l1.233-.317q1.6-.409,3.2-.794l2.022-.485V45.574l1.17-.261q1.467-.326,2.934-.631l1.712-.355.219-.321c2.788-4.1,5.622-8.194,8.426-12.176l.4-.575.7-.1q1.338-.2,2.676-.379l1.86-.25Z",
    transform: "translate(0 -1.293)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11119",
    "data-name": "Path 11119",
    d: "M12.827,49.222V46.481q-3.046.631-6.076,1.357V36.36q-1.59.381-3.175.788v14.28q4.6-1.18,9.229-2.141l.023,0",
    transform: "translate(-0.163 -1.659)",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11120",
    "data-name": "Path 11120",
    d: "M41.828,31.005c-.655.044-1.79.164-3.4.385q-.849.072-1.695.15V45.693q1.578-.146,3.156-.268V40.342c.842-.056,1.419-.092,1.731-.114a5.631,5.631,0,0,0,3.441-1.356,4.779,4.779,0,0,0,1.628-3.8,3.9,3.9,0,0,0-1.265-3.139,4.883,4.883,0,0,0-3.594-.93m-.761,6.855q-.591.042-1.181.087V33.633q.83-.1,1.333-.134c1.545-.107,2.318.557,2.318,1.968,0,1.49-.825,2.277-2.47,2.393",
    transform: "translate(-1.677 -1.414)",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11121",
    "data-name": "Path 11121",
    d: "M51.382,39.034q2.544-.057,5.087-.05V36.264q-2.544-.007-5.087.05V33.36q2.86-.064,5.72-.047v-2.78q-4.455-.026-8.908.143V44.957q4.715-.18,9.435-.139V42.039q-3.124-.027-6.247.043Z",
    transform: "translate(-2.2 -1.393)",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11122",
    "data-name": "Path 11122",
    d: "M62.421,30.621q-1.625-.049-3.247-.071V44.83q4.717.066,9.43.35v-2.8q-3.091-.188-6.183-.28Z",
    transform: "translate(-2.701 -1.394)",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11123",
    "data-name": "Path 11123",
    d: "M96.751,34.451Q90.91,33.3,85.024,32.491v2.8q2.13.292,4.255.629V47.4q1.62.258,3.236.541V36.464q2.122.372,4.235.79Z",
    transform: "translate(-3.881 -1.483)",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11124",
    "data-name": "Path 11124",
    d: "M105.672,36.484q-5.546,5.8-11.146,11.923,1.807.331,3.607.7,1.092-1.158,2.184-2.3,2.408.515,4.8,1.09v2.759q1.586.381,3.166.786v-14.3q-1.306-.335-2.614-.653M102.128,44.9q1.5-1.563,2.992-3.1v3.8q-1.493-.358-2.992-.693",
    transform: "translate(-4.315 -1.665)",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11125",
    "data-name": "Path 11125",
    d: "M24.642,32.788q-5.622,7.981-11.2,16.28,1.8-.371,3.6-.71,1.1-1.585,2.191-3.157,2.421-.427,4.848-.794v2.76q1.6-.243,3.212-.46v-14.3q-1.327.179-2.654.376m-3.582,9.806q1.51-2.15,3.023-4.276v3.8q-1.513.228-3.023.48",
    transform: "translate(-0.613 -1.479)",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11126",
    "data-name": "Path 11126",
    d: "M69.995,40.106a7,7,0,0,0,.637,2.078,6.838,6.838,0,0,0,.5.86,7,7,0,1,0-1.135-2.938",
    transform: "translate(-3.192 -1.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11127",
    "data-name": "Path 11127",
    d: "M79.928,35.143a4.44,4.44,0,0,0-2.717,1.5,7.725,7.725,0,0,0-.957,1.766c-.295.677-.565,1.366-.913,2.018a4.983,4.983,0,0,1-2.9,2.681,3.183,3.183,0,0,1-1.255.072,7,7,0,0,0,11.619-7.8,5.774,5.774,0,0,0-2.878-.231",
    transform: "translate(-3.249 -1.6)",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11128",
    "data-name": "Path 11128",
    d: "M75.934,32.19a7,7,0,0,0-5.3,9.993,2.555,2.555,0,0,0,2.33-.215A6.749,6.749,0,0,0,75.252,38.7a7.876,7.876,0,0,1,2.056-3.321,5.863,5.863,0,0,1,4.727-1.036,6.988,6.988,0,0,0-6.1-2.152",
    transform: "translate(-3.192 -1.466)",
    fill: "#161614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11129",
    "data-name": "Path 11129",
    d: "M77.342,35.479A7.882,7.882,0,0,0,75.286,38.8a6.751,6.751,0,0,1-2.291,3.268,2.556,2.556,0,0,1-2.329.216,6.97,6.97,0,0,0,.5.86,3.183,3.183,0,0,0,1.255-.072,4.985,4.985,0,0,0,2.9-2.681c.348-.652.618-1.341.913-2.018a7.721,7.721,0,0,1,.956-1.766,4.443,4.443,0,0,1,2.718-1.5,5.774,5.774,0,0,1,2.878.231,7,7,0,0,0-.714-.9,5.867,5.867,0,0,0-4.727,1.036",
    transform: "translate(-3.226 -1.566)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrk12);
export default __webpack_public_path__ + "static/media/wrk-12.80c9e1364d5a21ffa68947e7730c79b5.svg";
export { ForwardRef as ReactComponent };